import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslate } from "../../hooks/LanguageProvider";
import { Bounce, toast } from "react-toastify";

interface ModalNewSiteProps {
  show: boolean;
  onHide: () => void;
  onSuccess?: () => void;
}

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ModalNewSite: React.FC<ModalNewSiteProps> = ({ show, onHide, onSuccess }) => {
  const { translate } = useTranslate();

  const [formData, setFormData] = useState({
    site_name: "",
    location: ""
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.site_name) {
      toast.error("Site name is required.", {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const payload = {
        name: formData.site_name,
        location: formData.location || null,
      };

      const response = await fetch(`${backendUrl}/api/site/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const txt = await response.text();
        console.error("Error response create site:", txt);
        throw new Error("Error adding site");
      }

      toast.success("Site added successfully!");

      // Reset
      setFormData({ site_name: "", location: "" });

      if (onSuccess) onSuccess();
      onHide();
    } catch (error) {
      console.error("Error adding site:", error);
      toast.error("Error adding site. Check console.");
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{translate("New Site")}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="row g-3">
            {/* Site Name */}
            <div className="col-12">
              <Form.Group controlId="site_name">
                <Form.Label>{translate("Site Name")}</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.site_name}
                  onChange={handleChange}
                  placeholder="Enter site name"
                />
              </Form.Group>
            </div>

            {/* Location */}
            <div className="col-12">
              <Form.Group controlId="location">
                <Form.Label>{translate("Location")}</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Enter location (optional)"
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {translate("Close")}
          </Button>
          <Button variant="primary" type="submit">
            {translate("Add Site")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalNewSite;
